import React from 'react';

import withClass from '../../../hoc/withClass';
import classes from './Logo.module.css';
import logoImage from '../../../assets/images/STL-logo.png';

const STLLogo = () => <img src={logoImage} alt="STL logo" />;

export default withClass(STLLogo, classes.STLLogo);